module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/supplements_b0b1ea.png";